import { DocumentNode, gql, TypedDocumentNode, useMutation } from "@apollo/client";
import { useCallback } from "react";

import { GqlUserUpdateInput } from "~/__generated__";

export const USER_UPDATE = gql(`
mutation UserUpdate($input: GqlUserUpdateInput!) {
  userUpdate(input: $input) {
    id
    firstName
    lastName
    phone
    email
    profilePictureId
  }
}
`);

export default function useUserUpdate(userId: string, refetchQueries: (DocumentNode | TypedDocumentNode)[]) {
    const [updateUser, { data, loading, error }] = useMutation(USER_UPDATE, {
        refetchQueries,
    });

    return {
        updateUser: useCallback(
            (input: Omit<GqlUserUpdateInput, "userId">) =>
                updateUser({
                    variables: {
                        input: {
                            userId,
                            ...input,
                        },
                    },
                }),
            [updateUser, userId],
        ),
        data,
        loading,
        error,
    };
}
